import React, { useState } from 'react';
import { FaPhoneAlt, FaInstagram, FaTelegram, FaYoutube, FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../MotorradHeader.css';

const MotorradHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleTestDriveClick = () => {
        setIsMenuOpen(false);
        navigate('/test-drive');
    };

    // Новый обработчик — переход на страницу формы вместо модалки
    const handleOfferPageClick = () => {
        setIsMenuOpen(false);
        navigate('/get-offer');
    };

    return (
        <header className="motorrad-header">
            {/* 1. Верхняя панель */}
            <div className="top-bar">
                <div className="top-bar-container">
                    <div className="top-left">
                        <a href="tel:++998555018877"><FaPhoneAlt /> Телефон: +998 55 501 88 77 </a>
                    </div>
                    <div className="top-right">
                        <div className="social-links">
                            <a href="https://www.instagram.com/bmwmotorraduz/"><FaInstagram /></a>
                            <a href="https://t.me/bmwuzpa"><FaTelegram /></a>
                            <a href="https://www.youtube.com/@BMWUzbekistanPA"><FaYoutube /></a>
                        </div>
                        <div className="language-selector">
                            Язык: <span>RU</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. Основное меню */}
            <nav className="main-nav">
                <div className="nav-container">
                    <button className="burger-menu-btn" onClick={toggleMenu} aria-label="Открыть меню">
                        {isMenuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                    <ul className="nav-menu">
                        <li><Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Главная</Link></li>
                        <li><Link to="/moto_models" style={{ textDecoration: 'none', color: 'inherit' }}>Модели</Link></li>
                        <li><Link to="/service-request" style={{ textDecoration: 'none', color: 'inherit' }}>Запись на сервис</Link></li>
                        <li onClick={handleTestDriveClick}>Записаться на тест-драйв</li>
                        <li onClick={handleOfferPageClick}>Получить предложение</li>
                        <li className={location.pathname === '/contacts' ? 'active-link' : ''}>
                            <Link to="/contacts" style={{ textDecoration: 'none', color: 'inherit' }}>Контакты</Link>
                        </li>
                    </ul>

                    <div className="nav-logos">
                        <Link to="/motorrad">
                            <img src="/assets/BMW MOTORRAD LOGO BLACK2.svg" alt="BMW Motorrad" className="logo-motorrad" />
                        </Link>
                    </div>
                </div>
            </nav>

            {/* 3. Мобильная шторка */}
            <div className={`mobile-overlay-menu ${isMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-content">
                    <ul className="mobile-nav-links">
                        <li><Link to="/" onClick={toggleMenu}>Главная</Link></li>
                        <li><Link to="/moto_models" onClick={toggleMenu}>Модели</Link></li>
                        <li><Link to="/service-request" onClick={toggleMenu}>Запись на сервис</Link></li>
                        <li onClick={handleTestDriveClick}>Записаться на тест-драйв</li>
                        <li onClick={handleOfferPageClick}>Получить предложение</li>
                        <li><Link to="/contacts" onClick={toggleMenu}>Контакты</Link></li>
                    </ul>
                    <div className="mobile-menu-divider"></div>
                    <div className="mobile-menu-phone">
                        <a href="tel:++998555018877"><FaPhoneAlt /> Телефон: +998 55 501 88 77 </a>
                    </div>
                    <div className="mobile-menu-socials">
                        <a href="https://www.instagram.com/bmwmotorraduz/"><FaInstagram /></a>
                        <a href="https://t.me/bmwuzpa"><FaTelegram /></a>
                        <a href="https://www.youtube.com/@BMWUzbekistanPA"><FaYoutube /></a>
                    </div>
                    <div className="mobile-menu-lang">
                        Язык: <span>RU</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default MotorradHeader;